import React from 'react';
import styled from 'styled-components';
import { interaction } from '@origin-digital/reporting-client';
import { Link, Button, Text, Colors } from '@origin-digital/style-guide';

export interface IRequestQuoteProps {
  postcode: string;
  averageBill: string;
  usagePercentDuringDay: string;
  parentDataId?: string;
  isButton?: boolean;
}

const StyledLink = styled(Link)`
  color: ${Colors.RED};
  text-decoration: underline;
`;

export const RequestQuoteButton: React.FunctionComponent<IRequestQuoteProps> = ({
  postcode,
  averageBill,
  usagePercentDuringDay,
  parentDataId,
  isButton = true
}) => {
  let url = '/solar/quote';

  const mappedQS = {
    postcode: postcode,
    bill: Number(averageBill),
    mostUsage: Number(usagePercentDuringDay)
  };

  // Build the query string
  const qs = Object.entries(mappedQS)
    .reduce((_qs, [k, v]) => {
      _qs += `&${k}=${v.toString()}`;
      return _qs;
    }, '')
    .slice(1);

  url += `?${qs}`;

  return (
    <StyledLink href={url}>
      {!isButton ? (
        <Text
          data-id="requestCallLink"
          color="red"
          align="center"
          onClick={() =>
            interaction('click', {
              componentType: 'link',
              id: 'requestCallLink',
              parentContainer: parentDataId,
              appName: 'solar-calc',
              label: 'Request a call'
            })
          }
        >
          Request a call
        </Text>
      ) : (
        <Button
          data-id="orderButton"
          text="Order"
          block
          onClick={() =>
            interaction('click', {
              componentType: 'button',
              id: 'orderButton',
              parentContainer: parentDataId,
              appName: 'solar-calc',
              label: 'Order'
            })
          }
        />
      )}
    </StyledLink>
  );
};
